import * as React from 'react';
import styled from 'styled-components';

interface EllipsisButtonProps {
	className?: string;
	children?: JSX.Element | string;
	color?: string;
	onToggleClick?: () => void;
}

export default function EllipsisButton(props: EllipsisButtonProps) {
	const onToggleClick = () => {
		props.onToggleClick?.();
	};

	return (
		<Container className="btn-group dropright">
			<button
				type="button"
				className="btn dropdown-toggle"
				data-toggle="dropdown"
				aria-haspopup="true"
				aria-expanded="false"
				onMouseDown={onToggleClick}
			>
				<i className="fas fa-ellipsis-v" />
			</button>
			<div className="dropdown-menu">{props.children}</div>
		</Container>
	);
}

const Container = styled.div`
	.dropdown-toggle {
		box-shadow: none;
		padding: 0px 10px;
		&:after {
			content: unset;
		}
		i {
			font-size: 16px;
		}
	}
`;
